import { render, staticRenderFns } from "./GenderAgeDisplay.vue?vue&type=template&id=43ad5756&"
import script from "./GenderAgeDisplay.vue?vue&type=script&lang=js&"
export * from "./GenderAgeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports